import { Button as AntButton } from "antd-mobile"
import styled from "styled-components"

export type IButtonSize = "small" | "large" | "middle"

const SecondaryButton = styled(AntButton)<{
  $size?: IButtonSize
}>`
  height: ${({ $size }) => ($size === "small" ? "36px" : "48px")};
  padding: ${({ $size }) => ($size === "small" ? "6px 10px" : "12px 10px")};
  align-self: stretch;
  border-radius: 100px;
  background: var(
    --Schemes-Primary-container-Primary-Container-Variant,
    #cceded
  );
  backdrop-filter: blur(8px);
  border: none;

  &::before {
    border-radius: 100px;
  }

  span {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;

    color: var(
      --Schemes-Primary-container-On-Primary-Container-On-Primary-Container,
      #023648
    );

    text-align: center;
    font-family: proxima-nova;
    font-size: ${({ $size }) => ($size === "small" ? "14px" : "16px")};
    font-weight: ${({ $size }) => ($size === "small" ? "600" : "700")};
    line-height: 16px;
    letter-spacing: 0.16px;
  }
`

export default SecondaryButton
